const FETCH_MIXED_GRAPH_REQUEST = 'FETCH_MIXED_GRAPH_REQUEST';
const FETCH_MIXED_GRAPH_SUCCESS = 'FETCH_MIXED_GRAPH_SUCCESS';
const FETCH_MIXED_GRAPH_ERROR = 'FETCH_MIXED_GRAPH_ERROR';

const FETCH_MULTI_GRAPH_REQUEST = 'FETCH_MULTI_GRAPH_REQUEST';
const FETCH_MULTI_GRAPH_SUCCESS = 'FETCH_MULTI_GRAPH_SUCCESS';
const FETCH_MULTI_GRAPH_ERROR = 'FETCH_MULTI_GRAPH_ERROR';

const FETCH_SINGLE_REQUEST = 'FETCH_SINGLE_REQUEST';
const FETCH_SINGLE_SUCCESS = 'FETCH_SINGLE_SUCCESS';
const FETCH_SINGLE_ERROR = 'FETCH_SINGLE_ERROR';

const FETCH_DASHBOARD_SUMMARY_REQUEST = 'FETCH_DASHBOARD_SUMMARY_REQUEST';
const FETCH_DASHBOARD_SUMMARY_SUCCESS = 'FETCH_DASHBOARD_SUMMARY_SUCCESS';
const FETCH_DASHBOARD_SUMMARY_ERROR = 'FETCH_DASHBOARD_SUMMARY_ERROR';

const FETCH_MULTI_ENTITY_HIERARCHY_REQUEST =
    'FETCH_MULTI_ENTITY_HIERARCHY_REQUEST';
const FETCH_MULTI_ENTITY_HIERARCHY_SUCCESS = 'FETCH_ENTITY_HIERARCHY_SUCCESS';
const FETCH_MULTI_ENTITY_HIERARCHY_ERROR = 'FETCH_MULTI_ENTITY_HIERARCHY_ERROR';

const RESET_DASHBOARD_REQUEST = 'RESET_DASHBOARD_REQUEST';

const SHOW_DASHBOARD_LOADER = 'SHOW_DASHBOARD_LOADER';
const HIDE_DASHBOARD_LOADER = 'HIDE_DASHBOARD_LOADER';

export {
    FETCH_MIXED_GRAPH_REQUEST,
    FETCH_MIXED_GRAPH_SUCCESS,
    FETCH_MIXED_GRAPH_ERROR,
    FETCH_MULTI_GRAPH_REQUEST,
    FETCH_MULTI_GRAPH_SUCCESS,
    FETCH_MULTI_GRAPH_ERROR,
    FETCH_SINGLE_REQUEST,
    FETCH_SINGLE_SUCCESS,
    FETCH_SINGLE_ERROR,
    FETCH_DASHBOARD_SUMMARY_REQUEST,
    FETCH_DASHBOARD_SUMMARY_SUCCESS,
    FETCH_DASHBOARD_SUMMARY_ERROR,
    SHOW_DASHBOARD_LOADER,
    HIDE_DASHBOARD_LOADER,
    RESET_DASHBOARD_REQUEST,
    FETCH_MULTI_ENTITY_HIERARCHY_REQUEST,
    FETCH_MULTI_ENTITY_HIERARCHY_SUCCESS,
    FETCH_MULTI_ENTITY_HIERARCHY_ERROR,
};
